import { RoiModel } from '@telespot/sdk';

export class RoiModelUtils {
  static equalTo(model1: RoiModel, model2: RoiModel): boolean {
    return model1.className === model2?.className && model1.task?.name === model2.task?.name;
  }
}
